import React, { useEffect} from 'react';
import './AuthorizedPersonForm.css';
import RoutesConsts from "../../consts/RoutesConsts";
import FormContainer from "../../components/FormContainer/FormContainer";
import {
  TYPE_AUTO_COMPLETE,
  TYPE_ID,
} from "../../components/FormContainer/Field";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Page from '../../components/Page/Page';
import _ from 'lodash';
import { getAuthorizedPeople, upsertAuthorizedPeople } from '../../actions';
import { cleanFieldAutocompleteSearch, createFormField } from '../../actions/form';
import { useHistory } from 'react-router';
import { ContainerService } from '../../services/container';
import { cleanForm, formHasPersisted, formHasSubmitted, getAutocompleteFieldValue, getFormUseEffectArray, submitForm, updatedAutocompleteOptions } from '../../components/FormContainer/FormEffects';

const AuthorizedPersonForm: React.FC = (params: any) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const formStore = useSelector((state: any) => state.formState)

  const id: number = parseInt(params.match.params.id)
  const name = 'authorized_people_form'
  const backToRoute = RoutesConsts.AUTHORIZED_PERSON
  const title = 'Pessoas Authorizadas'

  const containerService = new ContainerService().build()

  const isEdit = () => {
    return id && id !== 0
  }

  const loadForm = (id: number) => {
    const fields = {
      "id": { type: TYPE_ID, name: "id", row: 1, group: "authorized_people", label: "Cod. Pessoa Authorizada", offset: 1, value: 0, validation: null },
      "peopleId": { type: TYPE_AUTO_COMPLETE, name: "peopleId", row: 2, offset: 0, group: "authorized_people", options: [], async: true, multiple: false, label: "Pessoa Autorizada", value: null, validation: Yup.object().nullable().required('Selecione alguma pessoa') },
      "parentPeopleId": { type: TYPE_AUTO_COMPLETE, name: "parentPeopleId", row: 2, offset: 0, group: "authorized_people", options: [], async: true, multiple: false, label: "Responsável", value: null, validation: Yup.object().nullable().required('Selecione algum responsável') },
      "condominiumId": { type: TYPE_AUTO_COMPLETE, name: "condominiumId", row: 3, offset: 1, group: "authorized_people", options: [], async: true, multiple: false, label: "Condominio", value: null, validation: Yup.object().nullable().required('Selecione algum condomium') },
    }

    //carrega form no redux - se nao colocar nao será renderizado pelo componente
    dispatch(createFormField(name, fields))

    if (isEdit()) {
      //altera campos de acordo com a edição
      console.log("Carregando dados do id", id)
      dispatch(getAuthorizedPeople(id, fields))
    }

  }

  const fetchAutocompleteCondominium = async (condominiumValue: any) => {
    const filter = {
      filter: {
        where: {
          name: { like: `${condominiumValue}%` }
        }
      }
    }

    const condominiums = await containerService.condominiumApiService.getCondominiums(filter)
    if (condominiums.data) {
      return condominiums.data.reduce((accCondominium: any, condominium: any) =>
        [...accCondominium, { id: condominium.id, label: `${condominium.id} - ${condominium.name}` }], [])
    }
    return []
  }

  const fetchAutocompletePeople = async (peopleValue: any) => {
    const filter = {
      filter: {
        where: {
          name: { like: `${peopleValue}%` }
        }
      }
    }

    const people: any = await containerService.peopleApiService.getPeoples(filter)
    if (people.data) {
      return people.data.reduce((accPeople: any, people: any) =>
        [...accPeople, { id: people.id, label: `${people.id} - ${people.name}` }], [])
    }
    return []
  }

  //init
  useEffect(() => {
    //Carrega dados do formulario para redux
    //para cada form é necessario um dispatch para criar os dados no redux
    loadForm(id)

    return () => {
      //unmount
      dispatch(cleanFieldAutocompleteSearch(name))
    }
  }, [])

  //atualização de form
  useEffect(() => {
    //verificar se form data mudou
    if (formHasSubmitted(formStore, name)) {
      //envia para saga de criação de pessoas (cria usuario se for novo)
      submitForm(dispatch, formStore, name, upsertAuthorizedPeople)
    }

    //se o upsert mudar o formulario pra persister quer dizer que inseriu o dado ok
    if (formHasPersisted(formStore, name)) {
      //limpa estado do form - tentar colocar no unmount
      cleanForm(dispatch, name)
      history.push(backToRoute)
    }

    if (getAutocompleteFieldValue(formStore, name, "condominiumId")) {
      //atualiza os campos do autocomplete de condominiumId
      updatedAutocompleteOptions(dispatch, formStore, name, "condominiumId", fetchAutocompleteCondominium)
    }
    if (getAutocompleteFieldValue(formStore, name, "parentPeopleId")) {
      //atualiza os campos do autocomplete de condominiumId
      updatedAutocompleteOptions(dispatch, formStore, name, "parentPeopleId", fetchAutocompletePeople)
    }

    if (getAutocompleteFieldValue(formStore, name, "peopleId")) {
      //atualiza os campos do autocomplete de condominiumId
      updatedAutocompleteOptions(dispatch, formStore, name, "peopleId", fetchAutocompletePeople)
    }

    //ADICIONA O PERSIST E O SUBMITED E CAMPOS ADICIONAIS PARA AUTOCOMPLETE
  }, getFormUseEffectArray(formStore, name, [getAutocompleteFieldValue(formStore, name, "condominiumId"), getAutocompleteFieldValue(formStore, name, "peopleId"), getAutocompleteFieldValue(formStore, name, "parentPeopleId")]))

  return (
    <Page title={title} backToRoute={backToRoute}>
      <FormContainer name={name} />
    </Page>
  )
};

export default AuthorizedPersonForm;
